import { RootState } from '@app/index';
import { selectWithError } from '@shared/lib';

export const selectUser = ({ user }: RootState) => user.firebaseUser;
export const selectUserWithError = selectWithError(selectUser, 'user');
